import { render, staticRenderFns } from "./crypto.vue?vue&type=template&id=55b90ab0&scoped=true"
import script from "./crypto.vue?vue&type=script&lang=js"
export * from "./crypto.vue?vue&type=script&lang=js"
import style0 from "./crypto.vue?vue&type=style&index=0&id=55b90ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b90ab0",
  null
  
)

export default component.exports